module.exports = "/assets/data/3d1f31b1afe990f75bef9b2649509fa7-G46.data.json";